import { render, staticRenderFns } from "./Chems.vue?vue&type=template&id=2854af2a&"
import script from "./Chems.vue?vue&type=script&lang=js&"
export * from "./Chems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports